// extracted by mini-css-extract-plugin
export default {"revisionDropdown":"Wja4o48NwoGVnD4w2R7N"};